<template lang="pug">
.order-details
  .row(v-if="order")
    .col-sm-12
      .panel.panel-default
        .panel-heading
          .panel-title Order Details
          .text-center.loading(v-if="loading")
            i.fa.fa-spinner.fa-pulse.fa-spin
        .panel-body
          .container-fluid
            .row(v-if="order")
              label.col-sm-2.control-label Name
              .col-sm-4
                span(v-if="order.description") {{order.description}}
                em.text-muted(v-else) Name not set

              label.col-sm-2.control-label Product
              .col-sm-4
                a(v-if="order.product" @click="goToProduct") {{order.product.name}}
                em.text-muted(v-else) Product not set

            .row
              label.col-sm-2.control-label Code Size
              .col-sm-4
                span(v-if="order.size") {{order.size}}
                em.text-muted(v-else) Empty order

              label.col-sm-2.control-label Locked
              .col-sm-4
                i.fa(:class="order.locked ? 'fa-lock' : 'fa-unlock'")

            .row
              label.col-sm-2.control-label Sectioned
              .col-sm-4
                span {{order.sectioned ? 'Yes' : 'No'}}

              label.col-sm-2.control-label Creator
              .col-sm-4
                span {{order.creator.username}}

            .row
              label.col-sm-2.control-label Created
              .col-sm-4
                span {{order.created | date}}

              label.col-sm-2.control-label Schema
              .col-sm-4
                a(@click="goToSchema" v-if="order.metadata") {{order.metadata.schema.name}}
                em.text-muted(v-else) No schema set

            hr
            .row
              label.col-sm-2.control-label Active Recalls
              .col-sm-10
                PillsList(v-if="recall" :items="recall" :clickable="true" @itemClick="goToRecall")
                em.text-muted(v-if="recall && recall.length === 0") No active recalls
                em.text-muted {{ recallError }}
</template>

<script>
import { dateFilter } from '@/filters/filters'
import PillsList from '@/components/common/PillsList'

export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    recall: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    recallError: {
      type: String,
      required: false
    }
  },
  methods: {
    goToProduct() {
      this.$router.push(`/core/configuration/product/${this.order.product.id}`)
    },
    goToSchema() {
      this.$router.push(`/core/configuration/metadataschema/${this.order.metadata.schema.id}/view`)
    },
    goToRecall(data) {
      this.$router.push(`/trackntrace/configuration/recall/${data.name}`)
    }
  },
  components: {
    PillsList
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/OrderDetails.vue